var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
import { Icon } from './Icon';
import { SvgIcon } from './SvgIcon';
import { IconsContext } from './IconsContext';
/**
 * @hidden
 */
export var IconWrap = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _a, _b;
  var _c = React.useContext(IconsContext),
    type = _c.type,
    icons = _c.icons;
  var icon = props.icon,
    fontIconProps = __rest(props, ["icon"]);
  var name = type === 'svg' ? ((_a = props.icon) === null || _a === void 0 ? void 0 : _a.name) || props.name : props.name || ((_b = props.icon) === null || _b === void 0 ? void 0 : _b.name);
  name = name && icons && icons[name] && typeof icons[name] === 'string' ? icons[name] : name;
  var svg = name && icons && icons[name] && typeof icons[name] !== 'string' ? icons[name] : icon;
  return type === 'svg' && svg ? /*#__PURE__*/React.createElement(SvgIcon, __assign({}, props, {
    icon: svg,
    ref: ref
  })) : /*#__PURE__*/React.createElement(Icon, __assign({}, fontIconProps, {
    name: name,
    ref: ref
  }));
});
IconWrap.displayName = 'KendoIconWrap';